import { render, staticRenderFns } from "./CollectionPayment.vue?vue&type=template&id=223ad420&"
import script from "./CollectionPayment.vue?vue&type=script&lang=js&"
export * from "./CollectionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports